import { capitalize, get, upperFirst } from "lodash"
import { formatNumber, localeString } from "@/utils/numbers"
import Vue from "vue"


const toSafeString = (value) => {
  if (typeof value === "number") return value.toString()
  if (typeof value === "string") return value
  return ""
}

const lowerCase = (str) => toSafeString(str).toLowerCase()
const upperCase = (str) => toSafeString(str).toUpperCase()
const startCase = (str) => toSafeString(str).split(" ").map((word) => (word[0]?.toUpperCase() || "") + word.slice(1)).join(" ")

// String filters
Vue.filter("capitalize", capitalize)
Vue.filter("lowercase", lowerCase)
Vue.filter("uppercase", upperCase)
Vue.filter("upperfirst", upperFirst)
Vue.filter("startcase", startCase)

// Number filters
Vue.filter("formatNumber", formatNumber)
Vue.filter("localestring", localeString)

Vue.filter("get", get)

export {
  lowerCase,
  startCase,
  upperCase,
}
